/* eslint-disable no-nested-ternary */
/* eslint-disable indent */
/* eslint-disable operator-linebreak */
/* eslint-disable arrow-body-style */
/* eslint-disable array-callback-return */
import { useEffect, useState } from 'react';
import { Container, Row, Col, Image, Form } from 'react-bootstrap';
import isEmpty from 'lodash/isEmpty';
import { useNavigate } from 'react-router-dom';

import LicenseRow from './LicenseRow';
import DetailsModal from './detailsModal/DetailsModal';
import TableComponet from '../common/table/Table';
import PageHeader from '../common/pageHeader/PageHeader';
import TableHeader from '../common/table/TableHeader';
import TableBody from '../common/table/TableBody';
import SingleTableHeader from '../common/table/SingleTableHeader';

import CannabisLicenseHelper from '../../helpers/features/CannabisLicensesHelper';
import LodingIcon from '../../assets/images/spinner.gif';
import { StylePage } from '../styles/Page.styled';
import { getLicenseRecords } from '../../apis/cannabisLicenseApi';
import PaginationComponet from '../common/pagination/Pagination';
import PaginationDropdown from '../common/input/PaginationDropdown';
import StateValueHelper from '../../helpers/stateHelper';
import StyleForm from '../common/input/Form.styled';
import Search from '../common/search/Search';

import FilterDropDown from '../common/input/stateFilterDropDown/FilterDropDown';
import Permissions from '../auth/Permissions';
import store from '../../store/store';
import * as commonActions from '../../store/actions/common';
import AppButton from '../styles/ButtonLink.styled';

function CannabisLicenses() {
  const navigate = useNavigate();
  const [licenseData, setLicenseData] = useState([]);
  const [metaData, setMetaData] = useState({});
  const [selectedOption, setSelectedOption] = useState([]);
  const [dataFetchPayload, setDataFetchPayload] = useState(CannabisLicenseHelper.FETCH_PAYLOAD);
  const [totalLicenseRecords, setTotalLicenseRecords] = useState(0);
  const [isLoadingLicenseData, setIsLoadingLicenseData] = useState(false);
  const [searchParameter, setSearchParameter] = useState('');
  const [currentSortedTitle, setCurrentSortedTitle] = useState(
    CannabisLicenseHelper.DEFAULT_SORTING_PARAMETER,
  );
  const [isOpenDetailsModal, setIsOpenDetailsModal] = useState(false);
  const [showArchived, setShowArchived] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState({});

  const fetchLicenseData = async payload => {
    setIsLoadingLicenseData(true);
    try {
      const { data } = await getLicenseRecords(payload);
      if (data && data?.doc && !isEmpty(data.doc)) {
        setLicenseData(data.doc);
        setMetaData(data?.meta ?? {});
        setTotalLicenseRecords(data?.meta?.totalRecords || 0);
      } else {
        setLicenseData([]);
        setMetaData({});
        setTotalLicenseRecords(0);
      }
    } catch (error) {
      console.error('Error fetching license data:', error);
      store.dispatch(
        commonActions.showErrorAlert({
          type: 'error',
          delay: 4000,
          body: error,
          message: 'Something went wrong!',
        }),
      );
    } finally {
      setIsLoadingLicenseData(false);
    }
  };

  useEffect(() => {
    fetchLicenseData(dataFetchPayload);
  }, [dataFetchPayload]);

  const handleRecordsPerPage = records => {
    const params = {
      page: CannabisLicenseHelper.LICENSE_RECORDS_STARTING_PAGE,
      limit: Number(records),
    };
    setDataFetchPayload(prev => ({ ...prev, ...params }));
  };

  const handleLicenceTablePageNavigation = npage => {
    setDataFetchPayload(prev => ({ ...prev, page: npage }));
  };

  const handleFetchSortedLicenseData = sortBy => {
    const keyName = sortBy.db_key;
    if (currentSortedTitle === keyName) {
      // If the same column is clicked, toggle the order
      const newOrder = dataFetchPayload.sort.order === 'asc' ? 'desc' : 'asc';
      setDataFetchPayload(prev => ({
        ...prev,
        sort: { by: keyName, order: newOrder },
        page: CannabisLicenseHelper.LICENSE_RECORDS_STARTING_PAGE,
      }));
    } else {
      // If a different column is clicked, set order to 'asc'
      setDataFetchPayload(prev => ({
        ...prev,
        sort: { by: keyName, order: 'asc' },
        page: CannabisLicenseHelper.LICENSE_RECORDS_STARTING_PAGE,
      }));
    }
    setCurrentSortedTitle(keyName);
  };

  const handleStateChange = selectedOptions => {
    const states = selectedOptions.map(option => option.value);
    setDataFetchPayload(prev => ({
      ...prev,
      filters: {
        ...prev.filters,
        state_name: states,
      },
    }));
  };

  const handleSearch = searchParam => {
    const trimmedSearchParam = searchParam.trim();

    if (searchParam) {
      setSearchParameter(trimmedSearchParam);
    } else {
      setSearchParameter('');
    }

    setDataFetchPayload(prev => ({
      ...prev,
      filters: {
        ...prev.filters,
        search: trimmedSearchParam,
      },
      page: CannabisLicenseHelper.LICENSE_RECORDS_STARTING_PAGE,
    }));
  };

  const handleShowArchived = checked => {
    const { filters } = dataFetchPayload;

    if (checked) {
      filters.status = 3;
    } else {
      delete filters.status;
    }

    setDataFetchPayload(prev => ({
      ...prev,
      filters,
      page: CannabisLicenseHelper.LICENSE_RECORDS_STARTING_PAGE,
    }));
  };

  const handleSelectTableRow = rowData => {
    setSelectedRowData(rowData);
    setIsOpenDetailsModal(true);
  };

  const createLicense = () => {
    navigate('/cannabis-licenses/create');
  };

  return (
    <Container>
      <StylePage>
        <Row>
          <Col md={5}>
            <PageHeader
              title={CannabisLicenseHelper.PAGE_HEADER}
              subheader={`${totalLicenseRecords} Records`}
            />
          </Col>
          <Col md={6} className="d-flex justify-content-end">
            <Permissions permissionRole="STANDARD">
              <Search
                handleSearch={handleSearch}
                setSearchParameter={setSearchParameter}
                searchParameter={searchParameter}
              />
            </Permissions>
          </Col>
        </Row>
        <Row>
          <Col className="d-flex justify-content-end">
            <div className="text-right">
              <Permissions permissionRole="ADMIN">
                <AppButton fill="true" onClick={() => createLicense()}>
                  {CannabisLicenseHelper.ADD_NEW_LICENSES_FORM_LICESEN_SUBMIT_BUTTON_TEXT}
                </AppButton>
              </Permissions>
            </div>
          </Col>
        </Row>
        <Row className="d-flex align-items-center">
          <Col md={2} className="mb-3">
            <StyleForm className="state-dropdown">
              {/* <Image src={FilterIcon} /> */}
              <FilterDropDown
                options={StateValueHelper.STATES}
                isMulti
                isSearchable={false}
                // controlShouldRenderValue={false}
                closeMenuOnSelect={false}
                // hideSelectedOptions={false}
                // components={{ Options, MultiValue, animatedComponents }}
                placeholder="State"
                onChange={value => {
                  setSelectedOption(value);
                  handleStateChange(value);
                }}
                value={selectedOption}
              />
            </StyleForm>
          </Col>
          <Col md={2} className="admin-sarch">
            <Permissions permissionRole="ADMIN">
              <Search
                customClass="admin-search"
                handleSearch={handleSearch}
                setSearchParameter={setSearchParameter}
                searchParameter={searchParameter}
              />
            </Permissions>
          </Col>
          <Col md={2}>
            <Permissions permissionRole="ADMIN">
              <StyleForm>
                <Form.Group className="custom-checkbox-green">
                  <div className="d-flex justify-content-start">
                    <Form.Check
                      readOnly
                      type="checkbox"
                      id="disabledFieldsetCheck"
                      checked={showArchived}
                      onChange={e => {
                        setShowArchived(e.target.checked);
                        handleShowArchived(e.target.checked);
                      }}
                    />
                    <p style={{ marginLeft: '5px' }}>{CannabisLicenseHelper.SHOW_ARCHIVED}</p>
                  </div>
                </Form.Group>
              </StyleForm>
            </Permissions>
          </Col>
          <Col md={6} className="mb-3 d-flex justify-content-end">
            <PaginationDropdown handleRecordsPerPage={handleRecordsPerPage} />
            {metaData?.totalPages && metaData.totalPages > 1 && (
              <PaginationComponet
                totalPages={Number(metaData.totalPages)}
                currentPage={Number(metaData.currentPage)}
                handleTablePageNavigation={handleLicenceTablePageNavigation}
                nextPage={Number(metaData.currentPage) + 1}
              />
            )}
          </Col>
        </Row>
        <TableComponet className="small-table">
          <TableHeader>
            {CannabisLicenseHelper.LICENSES_TABLE_HEADERS.map(item => (
              <SingleTableHeader
                title={item}
                key={item.key}
                setCurrentSortedTitle={setCurrentSortedTitle}
                handleFetchSortedData={handleFetchSortedLicenseData}
                currentSortedTitle={currentSortedTitle}
              />
            ))}
          </TableHeader>
          <TableBody>
            {licenseData &&
              licenseData.length > 0 &&
              licenseData.map((item, i) => {
                return <LicenseRow data={item} key={item.id} selectedRow={handleSelectTableRow} />;
              })}
            {licenseData.length === 0 && !isLoadingLicenseData && (
              <tr className="without-data">
                <td colSpan="24">
                  <p>{CannabisLicenseHelper.NO_RECORDS_FOUND}</p>
                </td>
              </tr>
            )}
            {isLoadingLicenseData && (
              <tr className="loding-data">
                <td colSpan="24">
                  <Image src={LodingIcon} sizes="50px" />
                </td>
              </tr>
            )}
          </TableBody>
        </TableComponet>
      </StylePage>
      {isOpenDetailsModal && (
        <DetailsModal data={selectedRowData} handleDetailsModalClose={setIsOpenDetailsModal} />
      )}
    </Container>
  );
}

export default CannabisLicenses;
